const CONTINENT_CODES = {
  AMERICA: new Set([
    'US','CA','MX', 'BZ','CR','SV','GT','HN','NI','PA', 'AR','BO','BR','CL','CO','EC','FK','GF','GY','PE','PY','SR','UY','VE', 'AG','AI','AW','BB','BL','BM','BS','BQ','CW','DM','DO','GD','GP','HT','JM','KN','KY','LC','MF','MQ','MS','PM','SX','TC','TT','VC','VG'
  ]),
  ASIA: new Set([
    'AE','SA','KW','QA','OM','JO','IL','LB','TR', 'AM','AZ','BH','BD','BT','BN','KH','CN','HK','IN','ID','JP','KZ','KG','LA','MO','MY','MV','MN','MM','NP','OM','PK','PH','QA','SG','KR','LK','SY','TW','TJ','TH','TL','TM','UZ','VN'
  ]),
  EUROPE: new Set([
    'AD','AL','AT','AX','BA','BE','BG','CH','CZ','DE','DK','EE','ES','FI','FR','GB','GR','HR','HU','IE','IS','IT','JE','LT','LU','LV','MC','MD','ME','MK','MT','NL','NO','PL','PT','RO','RS','SE','SI','SK','SM','UA','VA','XK'
  ])
};

// 마켓 리스트 -> 객체 
function marketListToObject(marketList) {
  const sortedMarketList = {};
  marketList.forEach(market => {
    const regions = market.node.regions?.edges || [];
    const webPresence = market.node.webPresence?.rootUrls || [];
    const currency = market.node.currencySettings?.baseCurrency || '';
    regions.forEach(region => {
      sortedMarketList[region.node.name] = { 
        url: webPresence[0]?.url || '', 
        code: region.node.code, 
        currency: currency.currencyCode || '' 
      };
    });
  });
  return sortObjectByKey(sortedMarketList);
}

// 객체 키 정렬
function sortObjectByKey(obj) {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObject = {};
  sortedKeys.forEach(key => {
    sortedObject[key] = obj[key];
  });
  return sortedObject;
}

// 대륙 그룹화
function getContinentGroupForCode(code) {
  const upper = (code || '').toUpperCase();
  if (CONTINENT_CODES.AMERICA.has(upper)) return 'AMERICA';
  if (CONTINENT_CODES.ASIA.has(upper)) return 'ASIA';
  if (CONTINENT_CODES.EUROPE.has(upper)) return 'EUROPE';
  return 'REST OF THE WORLD';
}

function groupMarketListByContinent(sortedMarketList) {
  const groups = {
    'AMERICA': [],
    'ASIA': [],
    'EUROPE': [],
    'REST OF THE WORLD': []
  };
  Object.entries(sortedMarketList).forEach(([countryName, meta]) => {
    const group = getContinentGroupForCode(meta.code);
    groups[group].push({ name: countryName, meta });
  });
  Object.keys(groups).forEach(key => {
    groups[key].sort((a, b) => a.name.localeCompare(b.name));
  });
  return groups;
}

// 렌더링
function renderMarketList(currentMarket, marketList) {
  const marketSwitcherContainer = document.querySelectorAll(".market-switcher");
  const sortedMarketList = marketListToObject(marketList);
  const grouped = groupMarketListByContinent(sortedMarketList);

  const groupOrder = ['AMERICA', 'ASIA', 'EUROPE', 'REST OF THE WORLD'];
  const groupButtonsHTML = groupOrder.map(groupName => {
    const items = grouped[groupName] || [];
    return items.length ? `<div class="group-item" data-group-name="${groupName}"><span class="group-name">${groupName}</span></div>` : '';
  }).join("");

  const marketHTML = `
    <button class="market-switcher-trigger" data-market-trigger>
      <span>${currentMarket}  </span>
    </button>
    <div class="market-list" data-market-list>
      <div class="market-groups" data-market-groups>
        <div class="market-list-title">SELECT REGION</div>
        ${groupButtonsHTML}
      </div>
      <div class="market-detail" data-market-detail>
        <div class="market-detail-header market-list-title" data-market-back>
          <button type="button" class="market-back">←</button>
          <div class="market-detail-title" data-market-detail-title></div>
        </div>
        <div class="market-group-list" data-market-group-list></div>
      </div>
    </div>
  `;

  marketSwitcherContainer.forEach(container => {
    container.innerHTML = marketHTML;
    container.dataset.grouped = JSON.stringify(grouped);
  });

  setupHandlersOnce();
}

function setupHandlersOnce() {
  if (window.marketSwitcherHandlersInitialized) return;

  document.addEventListener('click', function(e) {
    const container = e.target.closest('.market-switcher');
    
    // 트리거 버튼 클릭
    const trigger = e.target.closest('[data-market-trigger]');
    if (trigger) {
      e.stopPropagation();
      const containerEl = trigger.closest('.market-switcher');
      const currentList = containerEl.querySelector('[data-market-list]');
      const isOpen = currentList.classList.contains('is-active');

      // 다른 스위처는 닫기 (현재 것은 상태에 따라 처리)
      document.querySelectorAll('.market-switcher [data-market-list].is-active').forEach(list => {
        if (list !== currentList) list.classList.remove('is-active');
      });
      document.querySelectorAll('.market-switcher [data-market-trigger].active').forEach(t => {
        if (t !== trigger) t.classList.remove('active');
      });

      if (isOpen) {
        // 이미 열려있으면 닫기
        currentList.classList.remove('is-active');
        trigger.classList.remove('active');
        document.dispatchEvent(new Event('lenis:start'));
      } else {
        // 닫혀있으면 열기
        currentList.classList.add('is-active');
        trigger.classList.add('active');
        document.dispatchEvent(new Event('lenis:stop'));
      }
      return;
    }

    // 그룹 아이템 클릭 (이벤트 위임)
    if (container) {
      const groupItem = e.target.closest('.group-item');
      if (groupItem && container.querySelector('[data-market-groups]').style.display !== 'none') {
        const groupName = groupItem.getAttribute('data-group-name');
        showGroupDetail(container, groupName);
        return;
      }
    }

    // 뒤로 가기 버튼 클릭
    const backBtn = e.target.closest('[data-market-back]');
    if (backBtn && container) {
      showGroupList(container);
      // 상세에서 목록으로 돌아와도 셀렉터는 열린 상태 유지
      return;
    }

    // 마켓 아이템(국가) 클릭
    const marketItem = e.target.closest('.market-item');
    if (marketItem) {
      const marketUrl = marketItem.getAttribute('data-market-url');
      const regionCode = marketItem.getAttribute('data-region-code');
      const switcherContainer = marketItem.closest('.market-switcher');
      if (switcherContainer && regionCode) {
        const triggerLabel = switcherContainer.querySelector('[data-market-trigger] span');
        triggerLabel.textContent = regionCode + '  ';
        localStorage.setItem('countryCode', regionCode);
        
        // 현재 URL에서 경로 부분 추출
        const currentMarket = window.location.pathname.split('/')[1];
        const currentPath = currentMarket.startsWith('en-') ? window.location.pathname.split('/').slice(2).join('/') : window.location.pathname.substring(1);
        const newUrl = marketUrl ? `${marketUrl}${currentPath}` : currentPath;
        window.location.href = newUrl;
      }
      // 선택 후 셀렉터 닫기
      switcherContainer.querySelector('[data-market-list]').classList.remove('is-active');
      switcherContainer.querySelector('[data-market-trigger]').classList.remove('active');
      document.dispatchEvent(new Event('lenis:start'));
      return;
    }


    // 셀렉터 외부 클릭 시 닫기
    if (!e.target.closest('.market-switcher')) {
      const anyOpen = document.querySelector('.market-switcher [data-market-list].is-active');
      document.querySelectorAll('.market-switcher [data-market-list].is-active').forEach(list => list.classList.remove('is-active'));
      document.querySelectorAll('.market-switcher [data-market-trigger].active').forEach(trigger => trigger.classList.remove('active'));
      if (anyOpen) document.dispatchEvent(new Event('lenis:start'));
    }
  });

  window.marketSwitcherHandlersInitialized = true;
}

function showGroupDetail(container, groupName) {
  const groupsEl = container.querySelector('[data-market-groups]');
  const detailEl = container.querySelector('[data-market-detail]');
  const detailTitleEl = container.querySelector('[data-market-detail-title]');
  const detailListEl = container.querySelector('[data-market-group-list]');
  
  const grouped = JSON.parse(container.dataset.grouped || '{}');
  const items = (grouped && grouped[groupName]) ? grouped[groupName] : [];

  detailTitleEl.textContent = groupName;
  const itemsHtml = items.map(({ name, meta }) => `
    <div class="market-item" data-market-url="${meta.url}" data-region-code="${meta.code}">
      <span class="item-name">${name} - ${meta.currency}</span>
    </div>
  `).join('');
  detailListEl.innerHTML = itemsHtml;

  groupsEl.style.display = "none";
  detailEl.style.display = "flex";
}

function showGroupList(container) {
  const groupsEl = container.querySelector('[data-market-groups]');
  const detailEl = container.querySelector('[data-market-detail]');
  groupsEl.style.display = "flex";
  detailEl.style.display = "none";
}

// 마켓 리스트 조회 API
async function getMarketList() {
  const url = `/market`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };
  
  try {
    const response = await fetchJson(url, options);
    if (response && response.data && response.data.markets) {
      return response.data.markets.edges;
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch market list:", error);
    return [];
  }
}